import { Box, ButtonBase, Drawer, Stack, SvgIcon } from '@mui/material';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import GroupIcon from '@mui/icons-material/Group';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import CustomTypography from '../../Typography/typography';
import styles from '../../../assets/styles/sidebar';
import logo from '../../../assets/images/logo1.png';

const SideBar = (props: any) => {
  const location = useLocation();
  const navigate = useNavigate();
  const classes = styles();
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1200);

  const items = [
    { title: 'Users', icon: GroupIcon, route: '/admin/dashboard' },
    { title: 'Report', icon: InsertDriveFileIcon, route: '/admin/report' },
  ];

  useEffect(() => {
    window.addEventListener('resize', () =>
      setIsDesktop(window.innerWidth > 1200)
    );
    return () =>
      window.removeEventListener('resize', () =>
        setIsDesktop(window.innerWidth > 1200)
      );
  }, []);

  const content = (
    <div className={classes.div}>
      <Box className={classes.box}>
        <Box>
          <Box className={classes.boxContainer}>
            <div className={classes.headingContainer}>
              <img
                src={logo}
                height={30}
                width={30}
                alt='logo'
                className={classes.logoContainer}
              />
              <CustomTypography
                color='inherit'
                className={classes.Title}
                variant='subtitle1'
              >
                B4Tax
              </CustomTypography>
            </div>
            <SvgIcon fontSize='small' sx={{ color: 'neutral.500' }}></SvgIcon>
          </Box>
        </Box>
        <Box component='nav' className={classes.navBox}>
          <Stack component='ul' spacing={0.5} className={classes.listStack}>
            {items.map((item) => (
              <li>
                <ButtonBase
                  className={classes.buttonBase}
                  sx={{
                    ...(location.pathname === item.route && {
                      backgroundColor: 'rgba(255, 255, 255, 0.16)',
                    }),
                  }}
                >
                  {item.icon && (
                    <Box component='span' className={classes.iconBox}>
                      <item.icon />
                    </Box>
                  )}
                  <Box
                    component='span'
                    className={classes.itemTitle}
                    onClick={() => navigate(item.route)}
                    sx={{
                      ...(item.title === 'Users' && {
                        color: 'common.white',
                      }),
                    }}
                  >
                    {item.title}
                  </Box>
                </ButtonBase>
              </li>
            ))}
          </Stack>
        </Box>
      </Box>
    </div>
  );

  if (isDesktop && props.open) {
    return (
      <Drawer
        anchor='left'
        open
        PaperProps={{ classes: { root: classes.papperProps } }}
        variant='permanent'
      >
        {content}
      </Drawer>
    );
  }

  return (
    <Drawer
      anchor='left'
      onClose={() => props.onClose()}
      open={props.open}
      PaperProps={{
        classes: { root: classes.smPaperProps },
      }}
      variant='temporary'
    >
      {content}
    </Drawer>
  );
};

export default SideBar;
